const SECTION_SELECTOR = '[data-gift-guide-cards]';

function initGiftGuideSection(section) {
  if (!(section instanceof HTMLElement)) return;
  if (section.dataset.giftGuideInit === 'true') return;

  section.dataset.giftGuideInit = 'true';

  const items = Array.from(section.querySelectorAll('.gift-guide-cards__item'));
  if (!items.length) return;

  const markAllVisible = () => {
    for (const item of items) {
      item.classList.add('is-revealed');
    }
  };

  markAllVisible();

}

function initAllGiftGuideSections(root = document) {
  const sections = root.querySelectorAll(SECTION_SELECTOR);
  for (const section of sections) {
    initGiftGuideSection(section);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllGiftGuideSections());
} else {
  initAllGiftGuideSections();
}

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  initAllGiftGuideSections(event.target);
});
